<template>
  <div>
    <div
      class="vp-group vp-p-2 vp-w-[208px] vp-flex vp-gap-2 vp-items-center vp-border-r vp-border-gray-200"
    >
      <TheAvatar
        :name="storeName.charAt(0)"
        :image="profilePicture"
        size="xxs"
        class="vp-shrink-0 vp-text-gray-500 vp-font-bold group-hover:vp-text-black"
      />
      <p class="vp-grow vp-font-semibold vp-truncate vp-text-left vp-ml-1">
        {{ storeName }}
      </p>
    </div>
  </div>
</template>

<script>
import TheAvatar from "./avatar.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    TheAvatar,
  },
  computed: {
    ...mapGetters({
      storeName: "store/name",
      profilePicture: "store/profilePicture",
    }),
  },
};
</script>
